import { render } from "./LightingTest.vue?vue&type=template&id=3558858c&scoped=true"
import script from "./LightingTest.vue?vue&type=script&lang=js"
export * from "./LightingTest.vue?vue&type=script&lang=js"

import "./LightingTest.vue?vue&type=style&index=0&id=3558858c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3558858c"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInnerLoading});
